import { responseHandleService } from './ResponseHandleService';
import AuthenticationService from './AuthenticationService';
import axios from 'axios';
import { appendAttachment } from '../utils/FormDataUtils';

export const reportsAndStudies = {
  getAll,
  createOrUpdate,
  search,
  deleteReport
};
const requestOptions = {
  method: 'GET',
  headers: {
    Accept: 'application/json',
    'Content-type': 'application/json'
  }
};
function search(searchReport, pageNumber) {
  let searchUrl = `${
    process.env.REACT_APP_API_URL
  }/api/reports_and_studies/search?title=${searchReport.title}&archiveYear=${
    searchReport.archiveYear
  }&page[number]=${pageNumber ? pageNumber : 1}`;

  return fetch(searchUrl, requestOptions).then(
    responseHandleService.handleResponse
  );
}

function getAll(pageNumber) {
  let url = `${
    process.env.REACT_APP_API_URL
  }/api/reports_and_studies/?page[number]=${pageNumber ? pageNumber : 1}`;

  return fetch(url, requestOptions)
    .then(responseHandleService.handleResponse)
    .catch(error => console.log(error));
}
function createOrUpdate(newReport) {
  const requestOptions = {
    method: newReport.id ? 'PUT' : 'POST',
    headers: {
      Accept: 'application/json'
    },
    body: createBodyRequest(newReport)
  };

  this.authentication = new AuthenticationService();

  if (this.authentication.loggedIn()) {
    requestOptions.headers['Authorization'] =
      'Bearer ' + this.authentication.getToken();
  }

  const url = `${process.env.REACT_APP_API_URL}/api/reports_and_studies${
    newReport.id ? `/${newReport.id}` : ''
  }`;

  return fetch(url, requestOptions).then(responseHandleService.handleResponse);
}
function createBodyRequest(report) {
  let formData = new FormData();

  formData.append('reports_and_studies[title]', report.title);
  formData.append('reports_and_studies[add_date]', report.date);

  const document = report.document;

  appendAttachment(formData, `reports_and_studies[document]`, document);

  return formData;
}
function deleteReport(reportId) {
  const requestOptionsDelete = {
    headers: {
      Accept: 'application/json'
    }
  };
  this.authentication = new AuthenticationService();

  if (this.authentication.loggedIn()) {
    requestOptionsDelete.headers['Authorization'] =
      'Bearer ' + this.authentication.getToken();
  }
  let url = `${process.env.REACT_APP_API_URL}/api/reports_and_studies/${reportId}`;

  return axios.delete(url, requestOptionsDelete);
}
